import { Route, Routes } from 'react-router-dom';
import './App.css'
import Home from '../Home/Home';
import Nav from '../Nav/nav.js';
import Guarantee from '../Guarantee/Guarantee';
import Footer from '../Footer/Footer';
import Gallery from '../Gallery/Gallery';
import Claims from '../claims/claims.js'
import QuickQuote from '../QuickQuote/QuickQuote.js';

function App() {
  return (
    <div className="App">
      <>
      <Nav />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/pictures-and-videos' element={<Gallery />} />
        <Route path='/our-guarantee' element={<Guarantee />} />
        <Route path='/insurance-claims' element={<Claims />} />
        <Route path='/quick-quote' element={<QuickQuote />} />
      </Routes>
      <Footer />
      </>
    </div>
  );
}

export default App;
